<template>
   <div class="sidebar-wrapper" data-simplebar="true" @mouseenter="$emit('hover', true)" @mouseleave="$emit('hover', false)" @focusin="$emit('hover', true)" @focusout="sairFoco">
      <div class="sidebar-header">
         <div class="sidebar-brand" role="button" tabindex="0" title="Página Inicial" aria-label="Escalador Gerencial — Página Inicial" @click="irParaPaginaInicial" @keydown.enter.prevent="irParaPaginaInicial" @keydown.space.prevent="irParaPaginaInicial">
            <div class="logo-icon logo-icon-theme" role="img" aria-label="Logotipo Escalador"></div>
            <h4 class="logo-text"><span class="d-block">Escalador</span><small class="d-block font-10 weight-500 color-theme">Gerencial</small></h4>
         </div>
         <button type="button" class="toggle-icon ms-auto" :title="mobile ? 'Fechar menu' : (collapsed ? 'Expandir menu' : 'Recolher menu')" :aria-label="mobile ? 'Fechar menu' : (collapsed ? 'Expandir menu' : 'Recolher menu')" @click="$emit('toggle')"><i :class="collapsed && !mobile ? 'bx bx-arrow-to-right' : 'bx bx-arrow-to-left'" aria-hidden="true"></i></button>
      </div>
      
      <ul class="metismenu" id="menu">
         <li class="menu-label">Geral</li>
         <li :class="{ 'mm-active': secaoMenuAtiva('pagina-inicial'), 'menu-route-active': secaoMenuAtiva('pagina-inicial') }" data-secao="pagina-inicial">
            <a href="#" title="Página Inicial" @click.prevent="selecionarSecao('pagina-inicial')">
               <div class="parent-icon"><i class='far fa-home'></i></div>
               <div class="menu-title">Página Inicial</div>
            </a>
         </li>
         <li class="menu-label" v-if="temAlgumCadastroVisivel">Cadastros</li>
         <li :class="{ 'mm-active': secaoMenuAtiva('representantes'), 'menu-route-active': secaoMenuAtiva('representantes') }" data-secao="representantes" v-if="podeAcessarSecao('representantes')">
            <a href="#" title="Representantes" @click.prevent="selecionarSecao('representantes')">
               <div class="parent-icon"><i class='far fa-walking'></i></div>
               <div class="menu-title">Representantes</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li :class="{ 'mm-active': secaoMenuAtiva('planos'), 'menu-route-active': secaoMenuAtiva('planos') }" data-secao="planos" v-if="podeAcessarSecao('planos')">
            <a href="#" title="Planos" @click.prevent="selecionarSecao('planos')">
               <div class="parent-icon"><i class='far fa-money-bill'></i></div>
               <div class="menu-title">Planos</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li :class="{ 'mm-active': secaoMenuAtiva('empresas'), 'menu-route-active': secaoMenuAtiva('empresas') }" data-secao="empresas" v-if="podeAcessarSecao('empresas')">
            <a href="#" title="Empresas" @click.prevent="selecionarSecao('empresas')">
               <div class="parent-icon"><i class='far fa-building'></i></div>
               <div class="menu-title">Empresas</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li v-if="podeAcessarSecao('contabilidades')" :class="{ 'mm-active': secaoMenuAtiva('contabilidades'), 'menu-route-active': secaoMenuAtiva('contabilidades') }" data-secao="contabilidades">
            <a href="#" title="Contabilidades" @click.prevent="selecionarSecao('contabilidades')">
               <div class="parent-icon"><i class="far fa-calculator"></i></div>
               <div class="menu-title">Contabilidades</div>
            </a>
         </li>
         <li :class="{ 'mm-active': secaoMenuAtiva('assinaturas'), 'menu-route-active': secaoMenuAtiva('assinaturas') }" data-secao="assinaturas" v-if="podeAcessarSecao('assinaturas')">
            <a href="#" title="Assinaturas" @click.prevent="selecionarSecao('assinaturas')">
               <div class="parent-icon"><i class='far fa-file-signature'></i></div>
               <div class="menu-title">Assinaturas</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li class="menu-label" v-if="podeAcessarSecao('relatorios')">Relatórios</li>
         <li :class="{ 'mm-active': secaoMenuAtiva('relatorios'), 'menu-route-active': secaoMenuAtiva('relatorios') }" data-secao="relatorios" v-if="podeAcessarSecao('relatorios')">
            <a href="#" title="Relatórios" @click.prevent="selecionarSecao('relatorios')">
               <div class="parent-icon"><i class='bx bx-bar-chart-alt-2'></i></div>
               <div class="menu-title">Relatórios</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li class="menu-label">Sistema</li>
         <li :class="{ 'mm-active': secaoMenuAtiva('changelog'), 'menu-route-active': secaoMenuAtiva('changelog') }" data-secao="changelog">
            <a href="#" title="Changelog" @click.prevent="selecionarSecao('changelog')">
               <div class="parent-icon"><i class='bx bx-history'></i></div>
               <div class="menu-title">Changelog</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li :class="{ 'mm-active': secaoMenuAtiva('tutoriais'), 'menu-route-active': secaoMenuAtiva('tutoriais') }" data-secao="tutoriais">
            <a href="#" title="Tutoriais" @click.prevent="selecionarSecao('tutoriais')">
               <div class="parent-icon"><i class='bx bx-video'></i></div>
               <div class="menu-title">Tutoriais</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li :class="{ 'mm-active': secaoMenuAtiva('atualizacoes'), 'menu-route-active': secaoMenuAtiva('atualizacoes') }" data-secao="atualizacoes">
            <a href="#" title="Atualizações Sistema" @click.prevent="selecionarSecao('atualizacoes')">
               <div class="parent-icon"><i class='bx bx-sync'></i></div>
               <div class="menu-title">Atualizações Sistema</div>
               <div class="accordion-button"></div>
            </a>
         </li>
         <li class="menu-label">Suporte</li>
         <li :class="{ 'mm-active': secaoMenuAtiva('support'), 'menu-route-active': secaoMenuAtiva('support') }" data-secao="support">
            <a href="#" title="Suporte / Report" @click.prevent="selecionarSecao('support')">
               <div class="parent-icon"><i class='bx bx-support'></i></div>
               <div class="menu-title">Suporte / Report</div>
               <div class="accordion-button"></div>
            </a>
         </li>
      </ul>
   </div>
</template>

<script>

import { mapState } from 'vuex'
import { canUserAccessPath, canUserAccessSection } from '@/services/commercial/panelPermissions'

export default {
	name: 'MenuLateral',
   props: { collapsed: Boolean, mobile: Boolean },
   computed: {
      ... mapState({
         secaoAtiva: state => state.secaoAtiva,
         dadosUsuario: state => state.dadosUsuario,
         secoes: state => state.secoes
      }),
      cadastrosSecoes() {
         return ['representantes', 'planos', 'empresas', 'contabilidades', 'assinaturas']
      },
      temAlgumCadastroVisivel() {
         return this.cadastrosSecoes.some(secao => this.podeAcessarSecao(secao))
      }
   },
   watch: {
      $route(to) { this.atualizarSecaoAtiva(to.path) }
   },
   methods: {
      podeAcessarSecao(secaoKey) {
         if (!this.dadosUsuario) return false
         return canUserAccessSection(this.dadosUsuario, secaoKey, this.secoes)
      },
      sairFoco(event) { if (!this.$el.contains(event.relatedTarget)) this.$emit('hover', false) },
      encontrarSecaoPorPath(path) {
         return Object.keys(this.secoes).find(secao => this.secoes[secao].tabs.some(tab => tab.path === path))
      },
      secaoMenuAtiva(secao) { return this.encontrarSecaoPorPath(this.$route.path) === secao },
      irParaPaginaInicial() { this.selecionarSecao('pagina-inicial') },
      selecionarSecao(secao) {
         const tabsPermitidas = (this.secoes[secao]?.tabs || []).filter(tab => canUserAccessPath(this.dadosUsuario, tab.path))
         const primeiraTab = tabsPermitidas[0] || this.secoes[secao]?.tabs[0]
         if (!primeiraTab) return
         if (secao !== this.secaoAtiva) this.$store.dispatch('setSecaoAtiva', secao)
         if (this.$route.path !== primeiraTab.path) this.$router.push(primeiraTab.path)
      },
      atualizarSecaoAtiva(path) {
         const secao = this.encontrarSecaoPorPath(path)
         if (secao && secao !== this.secaoAtiva) this.$store.dispatch('setSecaoAtiva', secao)
      }
   },
   // Os links são diretos; a seleção pertence ao Vue e à rota, sem toggle do MetisMenu.
   mounted() { this.atualizarSecaoAtiva(this.$route.path) }

}

</script>

<style scoped>
.logo-icon-theme {
   flex: 0 0 44px;
   height: 44px;
   background-image: var(--home-logo);
   background-color: #ffffff;
   background-repeat: no-repeat;
   background-position: center;
   background-size: calc(100% - 4px);
   border: 1px solid rgba(15, 23, 42, .08);
   border-radius: 9px;
}

.sidebar-brand {
   align-items: center;
   cursor: pointer;
   display: flex;
   min-width: 0;
   outline: none;
}

.sidebar-brand:focus-visible {
   border-radius: 8px;
   box-shadow: 0 0 0 .18rem color-mix(in srgb, var(--color-theme) 22%, transparent);
}

.sidebar-wrapper .metismenu > .menu-label {
   align-items: center;
   color: color-mix(in srgb, var(--color-theme) 78%, #334155);
   display: block;
   gap: 0;
   font-size: 10px;
   font-weight: 700;
   letter-spacing: .5px;
   line-height: 1;
   margin-top: 8px;
   padding: 12px 10px 4px;
   text-align: left;
   width: 100%;
}

.sidebar-wrapper .metismenu > .menu-label::after {
   display: none;
}

.sidebar-wrapper .metismenu > .menu-label:first-child {
   margin-top: 4px;
}

.sidebar-wrapper .metismenu a {
   border-radius: 8px;
   margin: 1px 6px;
   min-height: 34px;
   overflow: hidden;
}

.sidebar-wrapper .metismenu a .menu-title {
   flex: 1 1 auto;
   line-height: 1.25;
   min-width: 0;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}

.sidebar-wrapper .metismenu a .parent-icon {
   flex: 0 0 24px;
   text-align: center;
}

.sidebar-wrapper .metismenu a .accordion-button {
   display: none !important;
}

.sidebar-wrapper .metismenu .mm-active > a,
.sidebar-wrapper .metismenu .menu-route-active > a {
   background: var(--sidebar-active-bg);
   border-color: var(--sidebar-active-border);
   box-shadow: var(--sidebar-active-shadow);
   color: var(--sidebar-active-text);
   font-weight: 700;
}

.sidebar-wrapper .metismenu .mm-active > a .parent-icon,
.sidebar-wrapper .metismenu .menu-route-active > a .parent-icon {
   background: var(--sidebar-active-icon-bg);
   color: var(--sidebar-active-icon-text);
   box-shadow: var(--sidebar-active-icon-shadow);
}

@media screen and (min-width: 1025px) {
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {
      justify-content: center;
      height: 38px;
      margin: 3px auto;
      min-height: 38px;
      padding-left: 0;
      padding-right: 0;
      width: 42px;
   }

   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .mm-active > a,
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-route-active > a {
      box-shadow: none;
      border-color: var(--sidebar-active-border);
   }

   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .mm-active > a .parent-icon,
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-route-active > a .parent-icon {
      background: var(--sidebar-active-icon-bg);
      color: var(--sidebar-active-icon-text);
   }

   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a .parent-icon {
      flex-basis: auto;
      margin: 0;
   }

   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a .accordion-button,
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a .menu-title,
   .wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu > .menu-label {
      display: none !important;
   }
}


</style>
